import React, { useEffect, useRef } from "react";
import { ldGetClientSideId } from "./ldGetClientSideId";
import { LaunchDarklyOptions } from "@smartrr/shared/LaunchDarkly";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import { useLDIdentityCustomer } from "./useLDIdentityCustomer";

export function LDProviderWrapper({ children: Component }: { children: () => React.JSX.Element }) {
  const LDProviderComponentRef = useRef<React.ComponentType<{}> | null>(null);
  const context = useLDIdentityCustomer();

  useEffect(() => {
    if (!context) {
      return;
    }

    const clientSideID = ldGetClientSideId();
    LDProviderComponentRef.current = withLDProvider({
      context: context!,
      clientSideID,
      ...LaunchDarklyOptions,
    })(Component);
  }, [context]);

  if (!LDProviderComponentRef.current) {
    return <Component />;
  }

  const LDProviderComponent = LDProviderComponentRef.current;
  return <LDProviderComponent />;
}

export default LDProviderWrapper;
